export enum Load {
  High = "high",
  Mid = "mid",
  Low = "low"
}

export enum WidgetColumnSize {
  Large = 6,
  Medium = 4
}